import React, { useMemo } from 'react';
import ReactApexChart from 'react-apexcharts';
import { useTheme } from '@mui/material/styles';

export default function ProgressTimeline({ data = [] }) {
  const theme = useTheme();

  const chartData = useMemo(() => {
    // Sort data by timestamp
    const sortedData = [...data].sort((a, b) => 
      new Date(a.timestamp).getTime() - new Date(b.timestamp).getTime()
    );

    // Group data by days and calculate averages
    const dailyData = sortedData.reduce((acc, record) => {
      if (record && record.timestamp && typeof record.targetSoc === 'number') {
        const date = new Date(record.timestamp).toISOString().split('T')[0];
        if (!acc[date]) {
          acc[date] = { total: 0, count: 0, targetTotal: 0 };
        }
        acc[date].total += record.userSelectedTime || 0;
        acc[date].targetTotal += record.targetSoc;
        acc[date].count++;
      }
      return acc;
    }, {});

    // Convert to series format
    const timeData = [];
    const targetData = [];

    Object.entries(dailyData).forEach(([date, values]) => {
      const avgTime = values.total / values.count;
      const avgTarget = values.targetTotal / values.count;
      
      timeData.push([new Date(date).getTime(), avgTime]);
      targetData.push([new Date(date).getTime(), avgTarget]);
    });

    return [
      {
        name: 'Average Charging Time',
        data: timeData
      },
      {
        name: 'Average Target SOC',
        data: targetData
      }
    ];
  }, [data]);

  const options = {
    chart: {
      type: 'line',
      background: 'transparent',
      zoom: {
        enabled: true
      }
    },
    stroke: {
      curve: 'smooth',
      width: [3, 3]
    },
    title: {
      text: 'Charging Trends Over Time',
      align: 'left',
      style: {
        color: theme.palette.text.primary
      }
    },
    grid: {
      borderColor: theme.palette.divider
    },
    markers: {
      size: 4
    },
    xaxis: {
      type: 'datetime',
      labels: {
        style: {
          colors: theme.palette.text.secondary
        }
      }
    },
    yaxis: [
      {
        title: {
          text: 'Charging Time (hours)',
          style: {
            color: theme.palette.text.secondary
          }
        },
        labels: {
          style: {
            colors: theme.palette.text.secondary
          }
        }
      },
      {
        opposite: true,
        title: {
          text: 'Target SOC (%)',
          style: {
            color: theme.palette.text.secondary
          }
        },
        labels: {
          style: {
            colors: theme.palette.text.secondary
          }
        }
      }
    ],
    legend: {
      labels: {
        colors: theme.palette.text.secondary
      }
    },
    colors: [theme.palette.primary.main, theme.palette.secondary.main]
  };

  return (
    <ReactApexChart
      options={options}
      series={chartData}
      type="line"
      height={350}
    />
  );
}